<template>
  <BaseExtractedDetails 
    :sections="sections" 
    :has-data="hasData"
    :data="data"
  />
</template>

<script>
import BaseExtractedDetails from './BaseExtractedDetails.vue'

export default {
  name: 'BankStatementDetails',
  components: {
    BaseExtractedDetails
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasData() {
      return this.data && Object.keys(this.data).length > 0;
    },
    
    sections() {
      if (!this.data) return [];
      
      return [
        {
          title: 'Bank Statement Information',
          icon: 'las la-university',
          type: 'info-grid',
          fields: [
            {
              key: 'account_number',
              label: 'Account Number',
              format: 'text'
            },
            {
              key: 'bank_name',
              label: 'Bank Name',
              format: 'text'
            },
            {
              key: 'statement_period',
              label: 'Statement Period',
              format: 'dateRange'
            },
            {
              key: 'opening_balance',
              label: 'Opening Balance',
              format: 'currency'
            },
            {
              key: 'closing_balance',
              label: 'Closing Balance',
              format: 'currency'
            },
            {
              key: 'currency',
              label: 'Currency',
              format: 'text'
            }
          ]
        },
        
        // Transaction Summary
        ...(this.data.transaction_summary ? [{
          title: 'Transaction Summary',
          icon: 'las la-chart-bar',
          type: 'summary-grid',
          cards: [
            {
              key: 'transaction_summary.total_credits',
              label: 'Total Credits',
              format: 'currency'
            },
            {
              key: 'transaction_summary.total_debits',
              label: 'Total Debits',
              format: 'currency'
            },
            {
              key: 'transaction_summary.transaction_count',
              label: 'Transaction Count',
              format: 'text'
            }
          ]
        }] : [])
      ];
    }
  }
}
</script>
